import React, { useEffect, useState } from 'react';
import { 
  Character, 
  CharacterFeature, 
  CharacterFeatureBase, 
  CharacterFeatureSource,
  CharacterSheetInterface, 
} from "@dndModels";

// import DandDCharacterUtilities from "../../../utilities/character_utilities";

import CharacterFeatureBaseInput from "@dndComponents/character/features/CharacterFeatureBaseInput";

// const char_util = DandDCharacterUtilities.getInstance();

interface Props { 
  obj: CharacterFeature;
  source: CharacterFeatureSource;
  char: CharacterSheetInterface;
}

export default function CharacterFeatureFromSource({ 
  obj,
  source,
  char,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [char_feature_base, setCFB] = useState<CharacterFeatureBase | null>(null);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      load();
    }
  });
  
  useEffect(() => {
    if (!char_feature_base || char_feature_base.features.find(o => o.true_id === obj.true_id) === undefined) {
      load();
    }
    // eslint-disable-next-line
  }, [obj]);

  const load = () => {
    const cfb = char.mind.char_feature_bases.find(o => o.features.find(o2 => o2.true_id === obj.true_id) !== undefined);
    if (cfb) {
      setCFB(cfb);
    }
  }

  if (char_feature_base) {
    return (
      <CharacterFeatureBaseInput
        char={char}
        obj={char_feature_base}
        source={source}
        show_source
      />
    );
  } else {
    return <></>
  }
}
